<script>
  import BreadCrumbs from '@/components/BreadCrumbs'
  import CardsGrid from '@/components/CardsGrid'
  import isRelativeUrl from '@/mixins/isRelativeUrl'
  import { HeadMeta } from '@/utils/head-meta'

  export default {
    components: {
      CardsGrid,
      BreadCrumbs
    },
    mixins: [isRelativeUrl],
    async asyncData ({ app, params, error }) {
      const { items } = await app.$contentful.getEntries({
        content_type: 'page',
        'fields.template': 'About',
        include: 2
      })
      return {
        page: items[0]
      }
    },
    head () {
      return HeadMeta(this.page.fields)
    },
    computed: {
      richText () {
        return this.page.fields.content.filter((content) => {
          return content.sys.contentType.sys.id === 'richText'
        })
      },
      cards () {
        const cardComponents = ['linkCard', 'callToAction']
        return this.page.fields.content.filter((content) => {
          const componentName = content.sys.contentType.sys.id
          return cardComponents.includes(componentName)
        })
      },
      breadcrumbs () {
        return [
          { title: 'Over examenbundel', slug: '/over-examenbundel' }
        ]
      }
    }
  }
</script>

<template>
  <article class="view view-about">
    <bread-crumbs :breadcrumbs="breadcrumbs" />
    <header class="view-header">
      <div class="container px-4 md:px-8">
        <div class="w-full md:w-10/12 xl:w-6/12 mx-auto">
          <animated-title>
            <h1 class="animate text-3xl md:text-5xl md:text-center pb-8 md:pb-20">
              {{ page.fields.title }}
            </h1>
          </animated-title>
        </div>
      </div>
    </header>
    <div class="rich-text container px-4 md:px-8 pb-10 md:pb-16">
      <div class="w-full lg:w-10/12 xl:w-8/12 mx-auto">
        <div class="flex flex-wrap -mx-4">
          <div
            v-for="(data, i) in richText"
            :key="i"
            class="w-full md:w-1/2 px-4 pb-10 md:pb-16"
          >
            <rich-text-content :content="data.fields.content" />
            <div
              v-if="data.fields.buttonLink"
              class="mt-10"
            >
              <e-button
                v-if="isRelativeUrl(data.fields.buttonLink)"
                tag="nuxt-link"
                :to="toRelativeUrl(data.fields.buttonLink)"
              >
                {{ data.fields.buttonText }}
              </e-button>
              <a
                v-else
                class="button button-primary"
                :href="data.fields.buttonLink"
                target="_blank"
              >
                {{ data.fields.buttonText }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <cards-grid :data="cards" />
    <flexible-content
      v-if="false"
      :content="page.fields.content"
    />
  </article>
</template>
